import React from 'react';

import Img from '../Img';
import { profileThumb } from '../../icons';

class ProfileImage extends React.PureComponent {
  imgRef = React.createRef();

  _errorHandler = () => {
    this.imgRef.current.src = profileThumb;
  };

  render() {
    return <Img ref={this.imgRef} onError={this._errorHandler} {...this.props} />;
  }
}

export default ProfileImage;
